import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';

const AccentWidget = ({ text, containerSettings }) => (
  <div className="container">
    <Container settings={containerSettings}>
      <div className="shift-two-cols">
        <div className="accent">{text}</div>
      </div>
    </Container>
  </div>
);

AccentWidget.title = 'Accent';
AccentWidget.preview = 'accent.png';
AccentWidget.category = 'Content';

AccentWidget.propTypes = {
  text: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

AccentWidget.defaults = {
  text: '„Искаме да бъдем щастливи!“ — казват хората. Е, добре, не са ли щастливи? Не им ли създаваме непрекъснато вълнения, развлечения? Това е всичко, за което живеем, нали? За удоволствия, за трепети. А трябва да се съгласиш, че нашата култура ти предлага колкото искаш удоволствия и трепети.',
  containerSettings: {},
};

AccentWidget.adminFields = {
  text: { type: 'textarea' },
};

export default AccentWidget;
